import FlyPrivateCard from './FlyPrivateCard';

export default FlyPrivateCard;
